import { render, staticRenderFns } from "./modify-formation.vue?vue&type=template&id=8ac2c5cc&scoped=true&"
import script from "./modify-formation.vue?vue&type=script&lang=js&"
export * from "./modify-formation.vue?vue&type=script&lang=js&"
import style0 from "./modify-formation.vue?vue&type=style&index=0&id=8ac2c5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac2c5cc",
  null
  
)

export default component.exports